var ActivityConstants = {

  COMMENT: 'activity_comment',
  LOAD_PREVIOUS: 'activity_load_prev'
}

export default ActivityConstants
